import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

interface NavbarProps {
  isTransparent?: boolean;
}

const navLinks = [
  { name: "首页", href: "/" },
  { name: "武侠", href: "/category/wuxia" },
  { name: "奇幻", href: "/category/fantasy" },
  { name: "恋爱", href: "/category/romance" },
  { name: "悬疑", href: "/category/suspense" },
  { name: "关于我们", href: "/about" },
];

export default function Navbar({ isTransparent = false }: NavbarProps) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isHome = location.pathname === "/";
  const transparent = isTransparent && isHome && !scrolled;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        transparent
          ? "bg-transparent"
          : "bg-background-50/95 backdrop-blur-sm border-b border-background-200/70"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className={`text-xl md:text-2xl font-bold whitespace-nowrap ${
              transparent ? "text-white" : "text-foreground-950"
            }`}
            style={{ fontFamily: "var(--font-heading)" }}
          >
            韩漫网
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 ${
                  location.pathname === link.href
                    ? transparent
                      ? "text-white border-b-2 border-white"
                      : "text-primary-500 border-b-2 border-primary-500"
                    : transparent
                      ? "text-white/80 hover:text-white"
                      : "text-foreground-600 hover:text-foreground-950"
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/category/fantasy"
              className={`px-5 py-2 text-sm font-medium rounded-full whitespace-nowrap transition-all duration-200 ${
                transparent
                  ? "bg-white/20 text-white hover:bg-white/30"
                  : "bg-primary-500 text-white hover:bg-primary-600"
              }`}
            >
              开始阅读
            </Link>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg ${
              transparent ? "text-white" : "text-foreground-950"
            }`}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileMenuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                onClick={() => setMobileMenuOpen(false)}
                className={`text-sm font-medium py-2 whitespace-nowrap ${
                  location.pathname === link.href
                    ? "text-primary-500"
                    : "text-foreground-600"
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/category/fantasy"
              onClick={() => setMobileMenuOpen(false)}
              className="px-5 py-2.5 text-sm font-medium text-center rounded-full bg-primary-500 text-white whitespace-nowrap"
            >
              开始阅读
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}